var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgKey = function SvgKey(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#25292D",
    d: "M8 .642a3.458 3.458 0 0 1 1.679 6.483v1.48a.5.5 0 0 1-.297.456.47.47 0 0 0-.281.428.47.47 0 0 0 .281.427.5.5 0 0 1 .297.457v1.409a.5.5 0 0 1-.297.456.468.468 0 0 0-.281.427c0 .185.11.351.28.426a.5.5 0 0 1 .298.458v.123c0 .932-.754 1.685-1.685 1.685H6.82a.5.5 0 0 1-.5-.5V7.125A3.458 3.458 0 0 1 8 .643zM8 7.56a3.54 3.54 0 0 1-.68-.066v6.864h.674c.329 0 .603-.23.67-.54a1.464 1.464 0 0 1 .015-2.316v-.848a1.465 1.465 0 0 1 0-2.33v-.83c-.22.044-.446.066-.679.066zm0-5.917A2.458 2.458 0 1 0 8 6.56a2.458 2.458 0 0 0 0-4.917zm0 .905a.5.5 0 1 1 0 1 .5.5 0 0 1 0-1z"
  })));
};
export default SvgKey;